import React from 'react';
import LogoWhite from './LogoWhite';
import styled from 'styled-components';
import mediaQuery from 'styled-media-query';
import Authentication from '../services/authentication';
import UserGroup from './UserGroup';
import { useSelector } from 'react-redux';
import { AppState } from '../stores';

const SystemManagerHeader: React.FC = () => {
  const user = useSelector((state: AppState) => state.authenticated.user);
  const accessTokenExpiresAt = useSelector(
    (state: AppState) => state.authenticated.accessTokenExpiresAt,
  );
  const authentication = new Authentication();

  const isAuthenticated = () => {
    return !!user && authentication.isSessionValid(accessTokenExpiresAt);
  };

  return (
          <Wrapper>
            <Left>
              <LogoWhite width={104}/>
            </Left>
            {isAuthenticated() &&
            <>
              <Right>
                <UserGroup/>
              </Right>
            </>
            }
          </Wrapper>
  );
};

// style
const Wrapper = styled.header`
    padding: 0 14px;
    width: 100%;
    height: 40px;
    background: #262F40;
    //border-bottom: 1px solid #D5D5D5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
`;

const Left = styled.div`
  min-width: 104px;
  ${mediaQuery.lessThan('medium')`
    width: 23px;
    min-width: 23px;
    overflow: hidden;
    img {
      min-width: 104px;
    }
  `}
`;

const Right = styled.div`
`;

export default SystemManagerHeader;
